import React, { useState, useEffect } from 'react'
import { postAPI } from '../../../app/api';

// HTML Assets Base URL
const HTML_ASSETS_URL = 'https://retechprime.com/be-college-ex-students-club/html/';

export default function CampusCareer() {
    const [campusCareerData, setCampusCareerData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showVideo, setShowVideo] = useState(false);

    // Function to convert YouTube URL to embed format
    const getEmbedUrl = (url) => {
        if (!url) return "";
        
        // If already an embed URL, ensure autoplay is enabled
        if (url.includes('youtube.com/embed/') || url.includes('youtu.be/embed/')) {
            return url.includes('autoplay=') ? url : url + (url.includes('?') ? '&' : '?') + 'autoplay=1';
        }
        
        // Extract video ID from various YouTube URL formats
        let videoId = '';
        
        // Standard YouTube URL: https://www.youtube.com/watch?v=VIDEO_ID
        if (url.includes('youtube.com/watch?v=')) {
            videoId = url.split('v=')[1]?.split('&')[0];
        }
        // Shortened YouTube URL: https://youtu.be/VIDEO_ID
        else if (url.includes('youtu.be/')) {
            videoId = url.split('youtu.be/')[1]?.split('?')[0];
        }
        // Mobile YouTube URL: https://m.youtube.com/watch?v=VIDEO_ID
        else if (url.includes('m.youtube.com/watch?v=')) {
            videoId = url.split('v=')[1]?.split('&')[0];
        }
        
        // If video ID found, create embed URL with autoplay
        if (videoId) {
            return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
        }
        
        // Return original URL if no conversion possible
        return url;
    };

    useEffect(() => {
        fetchCampusCareerData();
    }, []);

    const fetchCampusCareerData = async () => {
        try {
            setLoading(true);
            const response = await postAPI('campus-career/list-section-data', {});
            if (response?.status === 1) {
                setCampusCareerData(response.data);
            }
        } catch (error) {
            console.error('Error fetching campus career data:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <section className="career">
                <div className="container">
                    <div className="text-center py-5">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <>
            <section className="career">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-7">
                            <div className="heading text-center">
                                <h2>{campusCareerData?.title || 'From Campus to Career'}</h2>
                                {/* <span className="yellow-pill">{campusCareerData?.subtitle || 'Alumni Speak'}</span> */}
                                <p className="mt-3">
                                    {campusCareerData?.description ||
                                        'Our alumni have excelled in diverse fields across the globe. In this section, they share how their B E College experience shaped their professional journey and why staying connected through the Ex-Students\' Club still matters.'}
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-10 col-sm-12 col-12">
                            <figure>
                                <img
                                    src={campusCareerData?.video_thumbnail || `${HTML_ASSETS_URL}assets/images/home/video.png`}
                                    className="img-fluid"
                                    alt="Career Video"
                                    onClick={() => setShowVideo(true)}
                                    style={{ cursor: 'pointer' }}
                                />
                                <button
                                    className="play-btn"
                                    onClick={() => setShowVideo(true)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <img src={`${HTML_ASSETS_URL}assets/images/icon/video-icon.svg`} alt="Play" />
                                </button>
                            </figure>
                        </div>
                    </div>
                </div>
            </section>

            {/* Video Modal */}
            {showVideo && (
                <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.8)' }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered video-modal p-0">
                        <div className="modal-content" style={{ position: 'relative' }}>
                            <div className="modal-header" style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 9999, }}>
                                {/* <h5 className="modal-title">{campusCareerData?.title || 'From Campus to Career'}</h5> */}
                                <button
                                    type="button"
                                    onClick={() => setShowVideo(false)}
                                    style={{
                                        background: "#ffffff",
                                        border: "none",
                                        borderRadius: "5%",
                                        width: "40px",
                                        height: "40px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                        padding: "0"
                                    }}
                                    aria-label="Close"
                                >
                                    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2 2L18 18" stroke="#000000" strokeWidth="2" strokeLinecap="round" />
                                        <path d="M18 2L2 18" stroke="#000000" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </button>
                            </div>
                            <div className="modal-body p-0">
                                <div className="ratio ratio-16x9">
                                    <iframe
                                        width="560"
                                        height="315"
                                        src={getEmbedUrl(campusCareerData?.video_url) || "https://www.youtube.com/embed/ZK-rNEhJIDs?si=r7nqpgpC7tjEAVbr&autoplay=1"}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
